module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/contact-collector-panel-tablet-1fe8520f0f231736a0e9ccb6fdee2ef2.jpg";